global.BaseUrl = "https://admin.foodweb-ostrich.ksoftpl.com/api";
global.AssetsUrl = "https://admin.foodweb-ostrich.ksoftpl.com";

// global.BaseUrl = 'http://localhost/nautilius-backend/public/api';
// global.AssetsUrl = 'http://localhost/nautilius-backend/public';
